import { PgProviderAccountType } from '../../../lib/api/pgProviderRoute';

/** DB 에는 영문으로 저장되고 화면에는 한글만 노출한다. */
export const PG_PROVIDER_ACCOUNT_TYPE_LABEL: Record<PgProviderAccountType, string> = {
  general: '일반',
  liquidity: '환금성',
};

/** 계정타입 무관(NULL) 규칙에 쓰는 표기 */
export const ACCOUNT_TYPE_ANY_LABEL = '전체';

export const getAccountTypeLabel = (accountType: PgProviderAccountType | null): string =>
  accountType ? PG_PROVIDER_ACCOUNT_TYPE_LABEL[accountType] : ACCOUNT_TYPE_ANY_LABEL;

/**
 * 결제수단별 기본 PG 사 (코드 기본값).
 *
 * 🔴 amondz-user-api 의 `PaymentManager.defaultPgEngName` 과 반드시 같아야 한다.
 * 규칙에 매칭되지 않는 결제가 실제로 어디로 가는지를 시뮬레이터가 보여주기 위한 값이고,
 * 이 값이 어긋나면 화면만 거짓말을 하게 된다. user-api 기본값을 바꿀 때 여기도 같이 바꾼다.
 */
export const DEFAULT_PG_ENG_NAME_BY_PAY_METHOD_TYPE: Record<string, string> = {
  card: 'nice',
  trans: 'smartro',
  vbank: 'smartro',
  kakaopay: 'kakaopay',
  naverpay: 'naverpay',
  payco: 'payco',
  tosspay: 'tosspay',
};
